export const tableRowsPerPageOptions = [10, 25, 50, 100, 500];